/** @ignore */
export default {
  login: {
    staging: 'https://sss.staging.bjqtthirdbase.com/account/mobile/login.html',
    production: 'https://sss.bjqtthirdbase.com/account/mobile/login.html',
  },
  purchase: {
    staging: 'https://sss.staging.bjqtthirdbase.com/cashier/payments.html',
    production: 'https://sss.bjqtthirdbase.com/cashier/payments.html',
  },
};
